import { ErrorPage } from '@/components/errors';
import { useNavbarContext } from '@/components/container/context/navbar';
import { useGetAccountServices } from '@/hooks/api';
import { groupServiceAccounts } from '@/routes/(services)/-model/group-service-accounts';
import { ModuleName, Screen } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/(tv)/tv/')({
  component: RouteComponent,
  errorComponent: ErrorPage,
  staticData: {
    module: ModuleName.Tv,
    screen: Screen.LandingPage,
  },
});

/**
 * SA-less entry point for the TV area, so external apps can deep link to `/tv`
 * without knowing the service account. Goes straight to the only TV-capable
 * service account, or hands over to the TV picker when there is more than one.
 */
function RouteComponent() {
  const navigate = Route.useNavigate();
  const { setActiveSection, setSheetOpen } = useNavbarContext();
  const { data, isLoadingData } = useGetAccountServices();

  useEffect(() => {
    if (isLoadingData || !data) return;

    const tvAccounts = groupServiceAccounts(data.Holder?.ServiceAccounts ?? []).filter(
      (sa) => sa.HasTvService,
    );

    if (tvAccounts.length === 1) {
      void navigate({
        to: '/tv/$id',
        params: { id: tvAccounts[0].Id },
        search: {},
        replace: true,
      });
      return;
    }

    if (tvAccounts.length > 1) {
      setActiveSection('tv');
      setSheetOpen(true);
    }
    void navigate({ to: '/home', search: {} as never, replace: true });
  }, [data, isLoadingData, navigate, setActiveSection, setSheetOpen]);

  return <></>;
}
